/***
 * Created on 2024/2/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function QnapAuthAppStepContent({state, step}) {
    const  { t } = useTranslation();

    const currentPos = (current_step) => {
        if (step === current_step) return 'active';
        if (current_step < step) return 'done';
        if (current_step > step) return '';
    }

    return (
        <>
            <li className={`dialog-step-bar__step-item ${currentPos(1)}`}>
                <div className="dialog-step-bar__step-item__step">1</div>
                <div className="dialog-step-bar__step-item__label">{t('@Install app@')}</div>
                <div className="dialog-step-bar__step-item__arrow"></div>
            </li>
            <li className={`dialog-step-bar__step-item ${currentPos(2)}`}>
                <div className="dialog-step-bar__step-item__step">2</div>
                {
                    ['qrcode', 'approval'].includes(state?.method) &&
                    <div className="dialog-step-bar__step-item__label">{t('@Scan QR code@')}</div>
                }
                {
                    ['verification', 'totp'].includes(state?.method) &&
                    <div className="dialog-step-bar__step-item__label">{t('@Scan QR code and Verify@')}</div>
                }
                <div className="dialog-step-bar__step-item__arrow"></div>
            </li>
            {
                ['approval'].includes(state?.method) &&
                <li className={`dialog-step-bar__step-item ${currentPos(3)}`}>
                    <div className="dialog-step-bar__step-item__step">3</div>
                    <div className="dialog-step-bar__step-item__label">{t('@Approve@')}</div>
                    <div className="dialog-step-bar__step-item__arrow"></div>
                </li>
            }
        </>
    );
}

export default QnapAuthAppStepContent;